import { Container, Stack } from '@mui/system';
import { Typography, Box, Grid } from '@mui/material';
import Image1 from '@/app/assets/images/our-partners/01.png';
import Image2 from '@/app/assets/images/our-partners/02.png';
import Image3 from '@/app/assets/images/our-partners/03.png';
import Image4 from '@/app/assets/images/our-partners/04.png';
import Image5 from '@/app/assets/images/our-partners/05.png';
import Image6 from '@/app/assets/images/our-partners/06.png';
import Image7 from '@/app/assets/images/our-partners/07.png';
import Image8 from '@/app/assets/images/our-partners/08.png';
import Image9 from '@/app/assets/images/our-partners/09.png';
import Image10 from '@/app/assets/images/our-partners/10.png';
import Image11 from '@/app/assets/images/our-partners/11.png';
import Image12 from '@/app/assets/images/our-partners/12.png';
import Image13 from '@/app/assets/images/our-partners/13.png';
import Image14 from '@/app/assets/images/our-partners/14.png';
import Image15 from '@/app/assets/images/our-partners/15.png';
import Image16 from '@/app/assets/images/our-partners/16.png';
import Image17 from '@/app/assets/images/our-partners/17.png';
import Image18 from '@/app/assets/images/our-partners/18.png';
import Image19 from '@/app/assets/images/our-partners/19.png';
import Image20 from '@/app/assets/images/our-partners/20.png';
import Image21 from '@/app/assets/images/our-partners/21.png';

import { useTranslation } from 'react-i18next';

const OurPartners = () => {
  const { t } = useTranslation('landing');

  const partners = [
    { image: Image1, alt: 'Partner 1' },
    { image: Image2, alt: 'Partner 2' },
    { image: Image3, alt: 'Partner 3' },
    { image: Image4, alt: 'Partner 4' },
    { image: Image5, alt: 'Partner 5' },
    { image: Image6, alt: 'Partner 6' },
    { image: Image7, alt: 'Partner 7' },
    { image: Image8, alt: 'Partner 8' },
    { image: Image9, alt: 'Partner 9' },
    { image: Image10, alt: 'Partner 10' },
    { image: Image11, alt: 'Partner 11' },
    { image: Image12, alt: 'Partner 12' },
    { image: Image13, alt: 'Partner 13' },
    { image: Image14, alt: 'Partner 14' },
    { image: Image15, alt: 'Partner 15' },
    { image: Image16, alt: 'Partner 16' },
    { image: Image17, alt: 'Partner 17' },
    { image: Image18, alt: 'Partner 18' },
    { image: Image19, alt: 'Partner 19' },
    { image: Image20, alt: 'Partner 20' },
    { image: Image21, alt: 'Partner 21' },
  ];

  return (
    <section id='partners'>
      <Container
        maxWidth={'xl'}
        sx={{
          height: '100%',
        }}
      >
        <Stack direction='column' alignItems='center'>
          <Typography
            variant='h2'
            sx={{
              fontWeight: 600,
              fontSize: '34px',
              color: '#0B1370',
              marginBottom: '40px',
              textAlign: 'center',
            }}
          >
            {t('our_partners')}
          </Typography>

          <Box mt={10} mb={20}>
            <Stack
              direction='row'
              flexWrap='wrap'
              justifyContent='center'
              columnGap={6.5}
              rowGap={4}
            >
              {partners.map((partner, index) => (
                <Box key={index} display='flex' justifyContent='center'>
                  <Box
                    component='img'
                    src={partner.image}
                    alt={partner.alt}
                    sx={{
                      width: '100%',
                      maxHeight: '50px',
                      maxWidth: {
                        xs: '100px',
                        sm: '150px',
                        md: '200px',
                      },
                      objectFit: 'contain',
                      transition: 'transform 0.3s ease',
                      '&:hover': {
                        transform: 'scale(1.05)',
                      },
                    }}
                  />
                </Box>
              ))}
            </Stack>
          </Box>
        </Stack>
      </Container>
    </section>
  );
};

export default OurPartners;
